import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./en/index";
import vi from "./vi/index";

export const LANGUAGES = {
  en: "English",
  vi: "Tiếng Việt",
} as const;

const resources = {
  en: {
    translation: en,
  },
  vi: {
    translation: vi,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

export type Language = keyof typeof resources;
export type TranslationKey = keyof typeof resources.en;

export const getTranslation = (lang: Language = "en") => resources[lang].translation;

export const getLanguageName = () => {
  const lang = localStorage.getItem("language");
  return LANGUAGES[lang as Language];
};
